import { parseStringPromise } from 'xml2js';
import api from './api';
import { ICreditSimulationPayload } from '../interface/new-car.interface';

const API_GATEWAY_URL_PRODUCT = process.env.API_GATEWAY_URL_PRODUCT;
const API_GATEWAY_URL_CONTENT = process.env.API_GATEWAY_URL_CONTENT;

const globalSearch = (payload) => {
  return api.post('product/v1/global-search', null, payload);
};

const get360DefaultImage = async (selectedCar) => {
  try {
    const response = await api.get(selectedCar?.newCarExterior360Url);

    const result = await parseStringPromise(response?.data);
    const firstImageSrc =
      selectedCar?.newCarExterior360Url?.replace(/\/[^/]+$/, '/') +
      result.config.images[0].image[0].$.src;

    return firstImageSrc;
  } catch (error) {
    return selectedCar?.images?.[0]?.url;
  }
};

const getProduct = (params) => {
  return api.get(`product/v1/product-list${params ? `?slug=${encodeURIComponent(params)}` : ''}`);
};

const getProductsByCategory = (category, payload, isUseGatewayAPI?: boolean) => {
  const params = new URLSearchParams(payload).toString();
  const decodedParams = decodeURIComponent(params);

  return api.get(
    `product/v1/products?category=${category}&${decodedParams || ''}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );
};

const getProductDetail = (payload, config = {}, isUseGatewayAPI?) => {
  try {
    const params = {
      category: 'NEWCAR',
      ...payload,
    };
    const queryParams = new URLSearchParams(params).toString();
    return api.get(
      `product/v1/product-detail?${queryParams}`,
      isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT, ...config } : config,
      false,
      false,
      false
    );
  } catch (err) {
    return null;
  }
};

const getGalleryNewCar = (
  productCodeSlug = '',
  type = '',
  galleryType = '',
  page = '',
  isUseGatewayAPI?
) => {
  return api.get(
    `product/v2/new-car-product/gallery/${encodeURIComponent(
      productCodeSlug
    )}?type=${encodeURIComponent(type)}&galleryType=${galleryType}&page=${page}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );
};

const getAllGalleryNewCar = (productCodeSlug, galleryType, isUseGatewayAPI?) => {
  return api.get(
    `product/v2/new-car-product/all-gallery/${encodeURIComponent(productCodeSlug)}${galleryType ? '?galleryType=' + galleryType : ''}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );
};

const getListFaq = (type, code, isUseGatewayAPI?) =>
  api.get(
    `content/v1/faq?type=${type}&code=${code}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );

const getSpecification = (code) =>
  //hardcoding this to hit auto2000.co.id because we need to see the real data, will use another API for this that will be proxy-ed by MS
  api.get(`/p/${code}/full-specification`, {}, false, false, false);

const getReview = (type, code, isUseGatewayAPI?) =>
  api.get(
    `content/v1/review?type=${type}&code=${code}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );

const getNewProductToyotaDealerList = (payload, isUseGatewayAPI?) => {
  const params = new URLSearchParams(payload).toString().replace(/%3A/gi, ':');

  return api.get(
    `product/v1/products?category=NEWCAR&${params || ''}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );
};

const getInformation = (category, isUseGatewayAPI?) =>
  api.get(
    `product/v1/new-car-product/information/${encodeURIComponent(category)}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );

const getContent = (product, contentType, citycode, isUseGatewayAPI?) =>
  api.get(
    `product/v2/new-car-product/content/${encodeURIComponent(product)}/${encodeURIComponent(
      contentType
    )}?cityCode=${encodeURIComponent(citycode)}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );

const getSuperiority = (category, isUseGatewayAPI?) =>
  api.get(
    `product/v1/new-car-product/superiority/${encodeURIComponent(category)}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );

const getMainSpecification = (product, isUseGatewayAPI?) =>
  api.get(
    `product/v1/new-car-product/specification/${encodeURIComponent(product)}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );

const creditCalculator = (payload) => {
  return api.post('product/v2/new-car-product/creditcalculator', null, payload);
};

const getSimilar = (payload, isUseGatewayAPI?) => {
  const { productCode, type = '', variant = '' } = payload;
  return api.get(
    `product/v1/new-car-product/similar/${encodeURIComponent(productCode)}/${type}?variant=${variant}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );
};

const getCompareProduct = (payload) => {
  try {
    const params = new URLSearchParams(payload).toString();
    return api.get(
      `product/v1/compare-product?category=NEWCAR&${params || ''}`,
      {},
      false,
      false,
      false
    );
  } catch (err) {
    return null;
  }
};

const getSimilarProductDetail = (payload, isUseGatewayAPI?) => {
  try {
    const params = new URLSearchParams(payload).toString();
    return api.get(
      `product/v1/new-car-product/similar-products/details?${params || ''}`,
      isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
      false,
      false,
      false
    );
  } catch (err) {
    return null;
  }
};

const getCouponDiscounts = (payload: string, isUseGatewayAPI?: boolean) => {
  try {
    return api.get(
      `product/v1/coupon-product?productCode=${payload}`,
      isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {}
    );
  } catch (err) {
    return null;
  }
};

const getSyncCMS = () => api.get(`cms-sync/v1/product/get-hybris`, {}, false, false, false);

const buyNowServices = (params) => {
  try {
    return api.get(`/services/buy-now?${params}`, { baseURL: process.env.NEXT_PUBLIC_URL });
  } catch (err) {
    return null;
  }
};

const addToGlobalCart = (payload: {
  products: {
    code: string;
    quantity: number;
  }[];
  provinceCode: string;
  cityCode: string;
  branchCode: string;
}) => {
  try {
    return api.post('saphybris-proxy/v1/saphybris/global-cart', null, payload);
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getStockAvailability = (payload) => {
  try {
    return api.post(
      '/saphybris-proxy/v1/saphybris/products/stock',
      null,
      { ...payload },
      {
        baseURL: process.env.NEXT_PUBLIC_BASE_URL,
      }
    );
  } catch (err) {
    return null;
  }
};

const calculateCreditMock = () => {
  try {
    return api.get('/saphybris-proxy/v1/mockup/calculate-credit', {}, false, false, false);
  } catch (err) {
    return null;
  }
};

const calculateCredit = (payload: ICreditSimulationPayload) => {
  try {
    return api.post('/saphybris-proxy/v1/saphybris/finance-simulation', null, payload, {
      baseURL: process.env.NEXT_PUBLIC_BASE_URL,
    });
  } catch (err) {
    return null;
  }
};

export default {
  globalSearch,
  getProduct,
  getProductsByCategory,
  getProductDetail,
  getGalleryNewCar,
  getAllGalleryNewCar,
  getListFaq,
  getSpecification,
  getReview,
  getNewProductToyotaDealerList,
  getInformation,
  getContent,
  getSuperiority,
  getMainSpecification,
  creditCalculator,
  getSimilar,
  get360DefaultImage,
  getCompareProduct,
  getSimilarProductDetail,
  getCouponDiscounts,
  getSyncCMS,
  buyNowServices,
  addToGlobalCart,
  getStockAvailability,
  calculateCreditMock,
  calculateCredit,
};
